import * as React from 'react';
import type { Category } from '@/types';
import { Link } from '@tanstack/react-router';

export interface SubCategoriesProps {
  categories: Category[];
  pageNo: number;
  subcategoryId?: string | null;
  categoryId: string;
}

function generateUrl(category: Category, categoryId: string, pageNo?: number) {
  if (pageNo) {
    return `/products/${categoryId}/${category.id}?pageNo=${pageNo}`
  }
  return `/products/${categoryId}/${category.id}`
}

function generateClassName(category: Category | null, subcategoryId: string | null | undefined) {
  if (category === null && subcategoryId === 'all') {
    return "subcategory active";
  }
  if (subcategoryId == category?.id) {
    return "subcategory active";
  }
  return "subcategory";
}

export function SubCategories(props: SubCategoriesProps): React.ReactElement | null {
  const allProductsUrl = `/products/${props.categoryId}/all?pageNo=${props.pageNo}`
  if (props.categories.length) {
    return (
      <div className="flex justify-center align-middle gap-1 mb-4">
        <div className={generateClassName(null, props.subcategoryId)}><Link to={allProductsUrl}>All</Link></div>
        {props.categories.map(category => <div className={generateClassName(category, props.subcategoryId)}><Link to={generateUrl(category, props.categoryId, props.pageNo)}>{category.name}</Link></div>)}
      </div>
    )
  }
  return null;
}
